// extracted by mini-css-extract-plugin
export default {"videoClassModalWrapper":"VideoClassModal_videoClassModalWrapper__P6ffY","modalTitle":"VideoClassModal_modalTitle__znLlS","modalContent":"VideoClassModal_modalContent__hEm3w"};